import 'twin.macro';

import { Sparkles } from 'lucide-react';

const QuestionHighlight = ({ highlightCount }: { highlightCount: number }) => {
  return (
    <div tw="py-2 px-3 bg-[hsla(51, 100%, 50%, 1)] rounded-[100px] flex-row flex items-center justify-center absolute text-sm right-[-10%] sm:right-[-20%] top-0 md:top-[50%] md:translate-y-[-50%] gap-2 max-w-[72px] w-full h-[32px]">
      <Sparkles color="black" fill="black" size="16px" />
      <p tw="text-sm pt-1">{highlightCount}</p>
    </div>
  );
};

export default QuestionHighlight;
